export const COMPLAINT_SOURCE = ["Telephone line", "Email", "WhatsApp", "Hard Copy", "Other"];
export const WORK_CODE = ["Department/wings as Operations", "IT", "Corruption", "HR", "Monitoring"];